export const Button = ({ label, className, onClick }: Props) => {
  const innerClassName = `${fixedClass} ${className}`;

  return (
    <button className={innerClassName} type="button" onClick={onClick}>
      {label}
    </button>
  );
};

const fixedClass = `items-center px-4 py-2 border border-transparent text-sm font-medium uppercase
rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`;

interface Props {
  label: string;
  className?: string;
  onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
}
